import { useQuery } from 'react-query';
import BackgroundTaskService from 'resources/background-tasks/background-task.service';


export default function useGetBackgroundTasks({ types, statuses, userAuthId }, queryOptions) {
  return useQuery(
    ['background-tasks', userAuthId, types, statuses],
    () => BackgroundTaskService.getBackgroundTasks({ types, statuses, userAuthId }),
    queryOptions,
  );
}
